import { PRIORITY_ORDER } from '../../shared/services/helpers/ticket-rules.helper';
import { TicketUiModel } from '../../shared/ui-models/ticket.ui-model';

/**
 * Queue order: open before closed, emergencies first, then P1 → P4, then the
 * oldest update first, so the ticket waiting longest at a given urgency is on top.
 */
export function sortQueue(tickets: TicketUiModel[]): TicketUiModel[] {
  return [...tickets].sort(
    (a, b) =>
      Number(a.isClosed) - Number(b.isClosed) ||
      Number(b.emergency) - Number(a.emergency) ||
      PRIORITY_ORDER.indexOf(b.priority) - PRIORITY_ORDER.indexOf(a.priority) ||
      a.updatedAt.getTime() - b.updatedAt.getTime()
  );
}
